import axios from '@/axiosInterceptor';

const state = () => ({
  emails: [],
});
// const getters = {}

const actions = {
  async createEmail(
    _,
    {
      carrierId,
      value,
      isType,
      onboardingPackeId,
      alias,
      description,
      addressableType,
      addressableId,
    }
  ) {
    let body = {
      email_address: {
        carrier_id: carrierId,
        value: value,
        is_type: isType,
        email_addressable_type: addressableType
          ? addressableType
          : 'OnboardingPacket',
        email_addressable_id: addressableId ? addressableId : onboardingPackeId,
        rate_confirmation_delivery_alias: alias,
        rate_confirmation_delivery_alias_description: description,
      },
    };
    try {
      let res = await axios.post(
        `${process.env.API_MONITOR}/api/v1/email_addresses`,
        body
      );
      return res;
    } catch (e) {
      const handled = handleAxiosError(e);
      throw handled || e;
    }
  },
  async updateEmail(_, { id, carrierId, value, isType, alias, description }) {
    let body = {
      email_address: {
        carrier_id: carrierId,
        value: value,
        is_type: isType,
        rate_confirmation_delivery_alias: alias,
        rate_confirmation_delivery_alias_description: description,
      },
    };
    try {
      let res = await axios.patch(
        `${process.env.API_MONITOR}/api/v1/email_addresses/${id}`,
        body
      );
      return res;
    } catch (e) {
      handleAxiosError(e);
    }
  },
  async deleteEmail(_, id) {
    try {
      let res = await axios.delete(
        `${process.env.API_MONITOR}/api/v1/email_addresses/${id}`
      );
      return res;
    } catch (e) {
      handleAxiosError(e);
    }
  },
  async getEmails({ commit }, { query }) {
    try {
      let res = await axios.get(
        `${process.env.API_MONITOR}/api/v1/email_addresses${query}`
      );
      commit('setEmails', res.data);
    } catch (e) {
      handleAxiosError(e);
    }
  },
  async inactivateEmail(_, { id }) {
    try {
      let res = await axios.patch(
        `${process.env.API_MONITOR}/api/v1/email_addresses/${id}/inactivate_rate_confirmation_email`
      );
      return res;
    } catch (e) {
      handleAxiosError(e);
    }
  },
  async toggleActiveEmail(_, { id }) {
    try {
      let res = await axios.patch(
        `${process.env.API_MONITOR}/api/v1/email_addresses/${id}/toggle_active_inactive`
      );
      return res;
    } catch (e) {
      handleAxiosError(e);
    }
  },
};

function handleAxiosError(e) {
  const status = e.response?.status;
  if (
    axios.isAxiosError(e) &&
    status &&
    [401, 403, 404, 422].includes(status)
  ) {
    return e;
  } else {
    throw e;
  }
}

const mutations = {
  setEmails(state, emails) {
    state.emails = emails;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
